import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./mainLanding.scss";
//import screenshot from "./resources/Screenshot.png";
//import appNote_Ellipsometer from "./resources/Image_AppNoteEllipsometer.png";
//import box from "./resources/placeholder.png";
//import { useNavigate } from "react-router-dom";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";

const MainLanding = () => {
  //const navigate = useNavigate();

  // Scroll to top when the component mounts
  useEffect(() => {
    if (window.location.hostname === "app.speqqle.com") {
      window.location.replace("https://www.speqqle.com/");
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    // Add an id here for higher specificity in your SCSS
    <div id="mainLanding" className="mainLandingContainer">
      <div className="container py-5">
        {/* Navigation */}
        <LandingHeader />

       {/* BLANK PAGE — content intentionally left empty */}
        
      </div>
      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default MainLanding;
